// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b3507d61","945":"d59b716d"}[chunkId] + ".chunk.js";
};